import React, { useMemo } from 'react';
import { Card, Image, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import DefaultImage from './default-image.png';
import truncateText from '../../../../../../../utils/truncateText';
import { isImageFile, getFileExtension, FILE_RECT_ICONS } from '../../../../../../../utils/fileTypeIcons';
import './styles.css';

const CollectionCard = props => {
  const { collection, onClick } = props;

  const thumbnails = useMemo(() => {
    const productThumbnails = [];
    const vendorThumbnails = [];
    const attachmentThumbnails = [];
    collection?.collectionProducts?.map(product => {
      if (product.product?.images?.[0]) {
        productThumbnails.push({ url: product.product.images?.[0].sourceUrl, isImage: true });
      }
    });
    collection?.collectionVendorItems?.map(item => {
      if (item?.item.images?.[0]) {
        vendorThumbnails.push({ url: item?.item.images?.[0].sourceUrl, isImage: true });
      }
    });
    collection?.collectionAttachments?.map(item => {
      if (item?.url) {
        const isImage = isImageFile(item.fileType);
        const ext = getFileExtension(item.fileName);
        const icon = FILE_RECT_ICONS[ext];
        attachmentThumbnails.push({
          url: isImage ? item.url : (icon || item.url),
          isImage: isImage || !icon,
        });
      }
    });

    const merged = [...productThumbnails, ...vendorThumbnails, ...attachmentThumbnails].slice(0, 4);

    return merged;
  }, [collection]);

  return (
    <Card className="clients-v2-collection--card" onClick={onClick} hoverable>
      <div className="clients-v2-collection--card-header">
        <div>
          <span className="clients-v2-collection--card-header-title">
            <Tooltip title={collection.name}>
              {truncateText(collection.name, 22, { cutWords: true })}
            </Tooltip>
          </span>

          <span className="clients-v2-collection--card-header-subtitle">
            {collection.isShared ? 'Shared with client' : ''}
          </span>
        </div>

        <RightOutlined />
      </div>

      <div className="clients-v2-collection--card-body">
        {thumbnails.map((thumbnail, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={!thumbnail.isImage ? 'collection-file-icon-wrapper' : undefined}
          >
            <Image
              src={thumbnail.url}
              width={110}
              height={110}
              preview={false}
              fallback={DefaultImage}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CollectionCard;
